<template>
  <div class="page">
    <div class="goodscon">
      <div class="titlecon" v-if="inspectionDetail">
        <div class="titleleft">
          <span>分拨批次号: {{ inspectionDetail.distributionNo }}</span>
          <span v-if="inspectionDetail.createOperationInfo">分拨人: {{ inspectionDetail.createOperationInfo.userName }}</span>
          <span
           v-if="inspectionDetail.createOperationInfo" >分拨时间:
            {{inspectionDetail.createOperationInfo.operationTime}}</span>

          <span>分拨数量: {{ distributionCount }}</span>

          <span
            >状态:<span
              style="color: #e6a23c"
              v-if="inspectionDetail.state == 1"
              >已验收</span
            >
            <span style="color: #13ce66" v-if="inspectionDetail.state == 2"
              >部分验收
            </span>
            <span style="color: #ff4d51" v-if="inspectionDetail.state == 3"
              >未验收
            </span></span
          >
          <span
            >实收数量:
            <strong style="color: red">{{ distributionTotalCount }}</strong>
          </span>
        </div>
        <div class="titleright">
          <el-button type="warning" @click="isBack()" size="small"
            >返回</el-button
          >
        </div>
      </div>
      <div v-for="(item, index) in sumData" :key="index">
        <div class="comH2" @click="handleShopClick(item.goodsType)">
          <div>
            {{
              item.goodsType == 1
                ? "医疗类"
                : item.goodsType == 0
                ? "商品类"
                : "耗材类"
            }}
          </div>
          <i
            v-if="showType['showType' + item.goodsType]"
            class="el-icon-caret-bottom"
          ></i>
          <i v-else class="el-icon-caret-top"></i>
        </div>
        <el-table
          default-expand-all
          row-class-name="row-expand-cove"
          :ref="'table' + item.goodsType"
          v-show="showType['showType' + item.goodsType]"
          show-summary
          :data="item.procureItem"
          style="width: 100%"
          size="small"
        >
      
          <el-table-column label="商品名称">
            <template slot-scope="scope">
              <span>{{ scope.row.title }}</span>
            </template>
          </el-table-column>
          <el-table-column label="品牌">
            <template slot-scope="scope">
              <span>{{ scope.row.brand }}</span>
            </template>
          </el-table-column>
          <el-table-column label="规格" width="140">
            <template slot-scope="scope">
              <span>{{ scope.row.skuValue }}</span>
            </template>
          </el-table-column>
          <el-table-column label="单位" width="60">
            <template slot-scope="scope">
              <span>{{ scope.row.unit }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="分拨数量"
            prop="distributionCount"
            width="80"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.distributionCount }}</span>
            </template>
          </el-table-column>
          <el-table-column label="实收数量" width="100" prop="acceptanceInfo">
            <template slot-scope="scope">
              <span class="">{{ scope.row.count }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="80">
            <template slot-scope="scope">
              <span
                v-if="scope.row.distributionState==2
                "
              >
                <span style="color: #e6a23c">•</span>
                已验收
              </span>
              <span v-if="scope.row.distributionState == 1">
                <span style="color: #13ce66">•</span>
                未验收
              </span>
              <span
                v-if="
                  scope.row.acceptanceInfo &&
                  scope.row.acceptanceInfo.abnormalInfo &&
                  (scope.row.acceptanceInfo.abnormalInfo.leakageCount ||
                    scope.row.acceptanceInfo.abnormalInfo.overdueCount ||
                    scope.row.acceptanceInfo.abnormalInfo.brokenCount ||
                    scope.row.acceptanceInfo.abnormalInfo.switchCount)
                "
              >
                <span style="color: #ff4d51">•</span>
                异常
                {{
                  scope.row.acceptanceInfo.abnormalInfo.leakageCount +
                  scope.row.acceptanceInfo.abnormalInfo.overdueCount +
                  scope.row.acceptanceInfo.abnormalInfo.brokenCount +
                  scope.row.acceptanceInfo.abnormalInfo.switchCount
                }}
                <el-popover
                  popper-class="abnormalpopover"
                  placement="bottom"
                  trigger="click"
                >
                  <div class="abnormal">
                    <div>
                      漏发数量
                      {{
                        scope.row.acceptanceInfo.abnormalInfo.leakageCount
                      }}
                    </div>
                    <div>
                      过期数量
                      {{
                        scope.row.acceptanceInfo.abnormalInfo.overdueCount
                      }}
                    </div>
                    <div>
                      破损数量
                      {{ scope.row.acceptanceInfo.abnormalInfo.brokenCount }}
                    </div>
                    <div>
                      调换数量
                      {{ scope.row.acceptanceInfo.abnormalInfo.switchCount }}
                    </div>
                  </div>
                  <el-button
                    slot="reference"
                    type="text"
                    icon="el-icon-view"
                  ></el-button>
                </el-popover>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="验收状态" width="120">
            <template slot-scope="scope">
              <span
                v-if="scope.row.distributionState==2
                "
              >
                <span style="color: #e6a23c">•</span>
                已验收
              </span>
              <span v-if="scope.row.distributionState == 1">
                <span style="color: #13ce66">•</span>
                未验收
              </span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120">
           
            <template slot-scope="scope">
              <el-button
                type="text"
                :disabled="
                  scope.row.distributionCount == scope.row.count
                    ? true
                    : false
                "
                @click="abnormal(scope.row, scope.$index)"
                size="small"
              >
                验收
              </el-button>
            </template>
          </el-table-column>

        </el-table>
      </div>
      <el-form :model="acceptanceParam" style="margin-top: 20px">
        <el-form-item label="验货备注" label-width="80px">
          <el-input
            style="width: 300px"
            type="textarea"
            :rows="3"
            placeholder="请输入内容"
            v-model="acceptanceParam.remarks"
            size="small"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <el-dialog title="异常状态" :visible.sync="dialogVisible" width="30%">
        <div v-if="acceptItem" style="margin-bottom: 10px">
          商品名称 <span>{{ acceptItem.title }}</span>
        </div>
        <div v-if="acceptItem" style="margin-bottom: 10px">
          分拨数量 <span>{{ acceptItem.distributionCount }}</span>
        </div>
        <div v-if="acceptItem" style="margin-bottom: 10px">
          实收数量
          <el-input-number v-model="acceptItem.count"  controls-position="right" :min="1" :max="10000" style="width:100px" @change="handleFenboChange"></el-input-number>
        </div>
        <div v-if="acceptdetail">
          <span>状态</span>
          <div style="margin-bottom: 10px">
            漏发数量
            <el-input-number
              size="small"
              v-model="acceptdetail.abnormalInfo.leakageCount"
              :min="0"
              label="描述文字"
            ></el-input-number>
          </div>
          <div style="margin-bottom: 10px">
            过期数量
            <el-input-number
              size="small"
              v-model="acceptdetail.abnormalInfo.overdueCount"
              :min="0"
              label="描述文字"
            ></el-input-number>
          </div>
          <div style="margin-bottom: 10px">
            破损数量
            <el-input-number
              size="small"
              v-model="acceptdetail.abnormalInfo.brokenCount"
              :min="0"
              label="描述文字"
            ></el-input-number>
          </div>
          <div style="margin-bottom: 10px">
            调换数量
            <el-input-number
              size="small"
              v-model="acceptdetail.abnormalInfo.switchCount"
              :min="0"
              label="描述文字"
            ></el-input-number>
          </div>
        </div>
        <el-button type="warning" @click="sureabnormal" size="small"
          >确 定</el-button
        >
      </el-dialog>
      <div class="footer">
        <div></div>
        <div>
          <span style="margin-right: 10px"
            >验货数量
            <strong style="color: #ff0000">{{ distributionTotalCount }}</strong>
          </span>

          <el-button
            class="desc"
            :loading="loading"
            type="warning"
            @click="submiOnekey"
            size="small"
           v-if="$buttonAuthority('cangku2-caigouMendian-oneKey')" >一键验收</el-button
          >
          <el-button
            class="desc"
            :loading="loading"
            type="warning"
            @click="submiAcceptance"
            size="small"
            >验货完成</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getGoodsCodeInfo } from "@/api/stockApi.js";
import { shopAKeyAcceptance} from "@/api/shopPurchaseApi.js";
import { getDistributionInfo,shopAcceptance} from "@/api/shopPurchaseApiNew.js";
export default {
  data() {
    return {
      goodsCustomCode: "",
      showType: {
        showType0: true,
        showType1: true,
        showType7: true,
      },
      dialogVisible: false,
      sumData: [],
      inspectionDetail: {
        distributionGoods: [],
      },
      acceptanceParam: {
        distributionNo: this.$route.query.id,
        goodsList: [],
        remarks: "",
      },
      acceptItem: "",
      acceptdetail: "",
      loading: false,
    };
  },
  computed: {
    //计算各商品分拨总数量
    distributionCount() {
      let distributionCount = 0;
      this.inspectionDetail.distributionGoods.forEach((item) => {
        distributionCount += item.distributionCount;
      });
      return distributionCount;
    },

     //计算各商品实收总数量
    //  paidCount() {
    //   let disCount = 0;
    //   this.inspectionDetail.distributionGoods.forEach((item) => {
    //     console.log(item,'兖州');
    //     paidCount += item.acceptanceInfo.paidCount;
    //   });
    //   return disCount;
    // },
    // 计算分拨总数量
    distributionTotalCount() {
      let distributionTotalCount = 0;
      this.acceptanceParam.goodsList.forEach((item) => {
        distributionTotalCount += item.count;
      });

      return distributionTotalCount;
    },
  },
  methods: {
    fillterGoodsCustom(arry) {
      let custtomList = arry.filter((item) => {
        return item.is_check == true || item.goods_state == 4;
      });

      return custtomList;
    },
    getDistributionInfo(id) {
      getDistributionInfo({
        distributionNo: id,
      }).then((res) => {
        if (res.code == 0) {
          this.inspectionDetail = res.data;
          this.sumData = this.sumGoods(res.data.distributionGoods);
          console.log(this.sumData, this.inspectionDetail);
          this.acceptanceParam.remarks = res.data.remarks;
        }
      });
    },
    sumGoods(arry) {
      let sumData = [];

      arry.forEach((item) => {
        let index = sumData.findIndex((ele) => {
          return item.goodsType == ele.goodsType;
        });

        if (index == -1) {
          sumData.push({
            goodsType: item.goodsType,
            procureItem: [item],
          });
        } else {
          sumData[index].procureItem.push(item);
        }
      });
      return sumData;
    },
    submiAcceptance() {
      this.loading = true;
      console.log(this.acceptanceParam,'this.acceptanceParam');
      shopAcceptance(this.acceptanceParam).then((res) => {
        if (res.code == 0) {
          this.loading = false;
          this.$router.push({
            path: "/caigoumendianNew/shopPurchase",
            query: {
              tabs: 2,
            },
          });
        } else {
          this.loading = false;
        }
      });
    },
    // 一键验收
    submiOnekey(){
      this.loading = true;
      console.log(this.inspectionDetail.company_info.shop_id,'this.inspectionDetail');
      let params={
        distributionNo:this.acceptanceParam.distributionNo,
        isDistribution:false,
        toShopId:this.inspectionDetail.company_info.shop_id
      }
      shopAKeyAcceptance(params).then((res) => {
        if (res.code == 0) {
          this.loading = false;
          this.$message.error("已全部验收成功");
        }
      });
    },
    handleShopClick(type) {
      this.showType["showType" + type] = !this.showType["showType" + type];
    },
    //异常数据
    abnormal(row, index) {
      console.log(index, row,"异常数据");
      this.dialogVisible = true;
      this.acceptItem = row;
      this.acceptdetail = {
        procureGoodsId: row.id,
        title:row.title+row.skuValue,
        count:0,
        abnormalInfo: {
          leakageCount:
            row.acceptanceInfo && row.acceptanceInfo.abnormalInfo
              ? row.acceptanceInfo.abnormalInfo.leakageCount
              : 0,
          overdueCount:
            row.acceptanceInfo && row.acceptanceInfo.abnormalInfo
              ? row.acceptanceInfo.abnormalInfo.overdueCount
              : 0,
          brokenCount:
            row.acceptanceInfo && row.acceptanceInfo.abnormalInfo
              ? row.acceptanceInfo.abnormalInfo.brokenCount
              : 0,
          switchCount:
            row.acceptanceInfo && row.acceptanceInfo.abnormalInfo
              ? row.acceptanceInfo.abnormalInfo.switchCountyi
              : 0,
        },
      };
    },
    handleFenboChange(value){
      this.acceptdetail.count=value
         console.log(value,'???');
    },
    //确定
    sureabnormal() {
            console.log( this.acceptItem,this.acceptdetail,' this.acceptItem this.acceptItem');
      let inspecCount =
        this.acceptItem.count +this.acceptdetail.abnormalInfo.leakageCount +this.acceptdetail.abnormalInfo.overdueCount +this.acceptdetail.abnormalInfo.brokenCount +this.acceptdetail.abnormalInfo.switchCount;
      if (this.acceptItem.distributionCount < inspecCount) {
        this.$message.error("实收数量和异常数量之和，已经大于分拨数量了");
      } else {
        this.acceptItem["acceptanceInfo"] = {};
        this.acceptItem["acceptanceInfo"]["abnormalInfo"] =this.acceptdetail.abnormalInfo;
        console.log(this.acceptdetail);
        this.acceptanceParam.goodsList.push(this.acceptdetail);
        this.dialogVisible = false;
      }
      console.log( this.acceptanceParam.goodsList,'//////')
    },
    isBack() {
      this.$alert("你正在验货,返回数据将不会保存,确认返回", "确认返回", {
        confirmButtonText: "确定",
        callback: (action) => {
          if (action == "confirm") {
            if (this.$route.query.refer) {
              this.$router.back();
            } else {
              this.$router.push({
                path: "/caigoumendianNew/shopPurchase",
                query: {
                  tabs: 2,
                },
              });
            }
          } else {
            this.$message({
              type: "info",
              message: "取消返回",
            });
          }
        },
      });
    },
  },
  created() {
    this.getDistributionInfo(this.$route.query.id);
  },
};
</script>

<style lang="scss">
.titlecon {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  background-color: #fff;
  margin-bottom: 10px;
  .titleleft {
    span {
      margin: 10px 20px;
      display: inline-block;
    }
  }

  .titleright {
    margin-right: 20px;
    // margin-top: 20px;
  }
}

.comH2 {
  line-height: 50px;
  font-size: 16px;
  display: flex;
  align-items: center;
}

.abnormalpopover {
  background-color: #000000;
  color: #fff;
}

.row-expand-cove .el-table__expand-icon {
  display: none;
}

.footer {
  background-color: #f5f5f5;
  position: fixed;
  bottom: 0;
  height: 50px;
  line-height: 50px;
  display: flex;
  justify-content: space-between;
  left: 220px;
  right: 0;
  padding-left: 20px;
  z-index: 200;

  .desc {
    margin-right: 20px;
  }
}
</style>
